export const iconSize = {
  small: 15,
};
